import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ConfigService} from '../../services/config.service';
import {Config} from '../../domain/config';
import {Observable} from 'rxjs';
import {NotificationService} from '../../services/notification.service';

@Component({
  selector: 'tech-core-quiz-misc-settings',
  standalone: false,
  templateUrl: './misc-settings.component.html',
  styleUrl: './misc-settings.component.scss'
})
export class MiscSettingsComponent implements OnInit {

  public rewardMessageFormGroup: FormGroup
  public rewardMessageInput: FormControl<string | null>;

  public usernameMessageFormGroup: FormGroup
  public usernameMessageEnabledSlider: FormControl<boolean | null>
  public usernameMessageInput: FormControl<string | null>;

  public attemptsConfigFormGroup: FormGroup
  public attemptsEnabledSlider: FormControl<boolean | null>
  public attemptCooldownInput: FormControl<string | null>

  constructor(
    public fb: FormBuilder,
    private configService: ConfigService,
    private notificationService: NotificationService
  ) {
    this.rewardMessageInput = new FormControl('', [Validators.required]);
    this.usernameMessageEnabledSlider = new FormControl(true);
    this.usernameMessageInput = new FormControl('', [Validators.required]);
    this.attemptsEnabledSlider = new FormControl(false);
    this.attemptCooldownInput = new FormControl('', [Validators.required]);

    this.rewardMessageFormGroup = this.fb.group({
      rewardMessageInput: this.rewardMessageInput,
    })

    this.usernameMessageFormGroup = this.fb.group({
      usernameMessageEnabledSlider: this.usernameMessageEnabledSlider,
      usernameMessageInput: this.usernameMessageInput,
    })

    this.attemptsConfigFormGroup = this.fb.group({
      attemptsEnabledSlider: this.attemptsEnabledSlider,
      attemptCooldownInput: this.attemptCooldownInput,
    })
  }

  ngOnInit() {
    this.loadConfig()
  }

  loadConfig() {
    this.configService.getConfig().subscribe({
      next: (config: Config) => {
        this.rewardMessageFormGroup.controls['rewardMessageInput'].patchValue(config.rewardMessage)
        this.usernameMessageFormGroup.controls['usernameMessageEnabledSlider'].patchValue(config.usernameMessageEnabled)
        this.usernameMessageFormGroup.controls['usernameMessageInput'].patchValue(config.usernameMessage)
        this.attemptsConfigFormGroup.controls['attemptsEnabledSlider'].patchValue(config.attemptsEnabled)
        this.attemptsConfigFormGroup.controls['attemptCooldownInput'].patchValue(config.attemptCooldown)
      }
    })
  }

  updateRewardMessage() {
    this.configService.updateConfigRewardMessage(this.rewardMessageFormGroup.controls['rewardMessageInput'].value).subscribe({
      next: value => {
        this.notificationService.success("Reward Message was changed")
        this.loadConfig()
      }, error: err =>  {
        this.notificationService.failure("Error when changing Reward Message")
      }
    })
  }

  updateUsernameMessage() {
    this.configService.updateUsernameMessage(
      this.usernameMessageFormGroup.controls['usernameMessageEnabledSlider'].value,
      this.usernameMessageFormGroup.controls['usernameMessageInput'].value
    ).subscribe({
      next: value => {
        this.notificationService.success("Sign-up Message was changed")
        this.loadConfig()
      }, error: err =>  {
        this.notificationService.failure("Error when changing Sign-up Message")
      }
    })
  }

  updateAttemptsConfig() {
    this.configService.updateAttemptsConfig(
      this.attemptsConfigFormGroup.controls['attemptsEnabledSlider'].value,
      this.attemptsConfigFormGroup.controls['attemptCooldownInput'].value).subscribe({
      next: config => {
        this.notificationService.success("Attempt Settings were successfully changed")
        this.loadConfig()
      }, error: err => {
        this.notificationService.failure("Error changing Attempt Settings")
      }
      }
    )
  }
}
